// extracted by mini-css-extract-plugin
module.exports = {"block":"style_block__38eQu","image":"style_image__16331","change-image":"style_change-image__3gOrr","text":"style_text__1YWXy","change-text":"style_change-text__rVD8s"};